"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueId = void 0;
var currentId = 0; // This is defined in its own file so that it can be mocked in jest tests. Jest can only
// mock an entire module at once, so putting it directly in a component file would mean
// that all other functions in that file would have to be mocked as well. This function
// is not exported to consumers.

var getUniqueId = function getUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  currentId += 1;
  return "".concat(prefix).concat(currentId);
};

exports.getUniqueId = getUniqueId;